import React from 'react'

import SliceManager from 'components/shared/SliceManager'
import UseCaseHero from 'components/shared/UseCaseHero'
import { getDataDependencies } from 'services/api'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

import PreviewBanner from 'components/shared/PreviewBanner'

import delve from 'dlv'

const WhyStrapi = ({ pageData, preview }) => {
  const useCaseHero = delve(pageData, 'useCaseHero')
  const slices = delve(pageData, 'slices')

  return (
    <>
      {preview && <PreviewBanner />}
      {useCaseHero && <UseCaseHero {...useCaseHero} />}
      {slices && <SliceManager slices={slices} />}
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const data = await fetchSingleType('why-strapi', preview)
  const pageData = await getDataDependencies(data)

  return {
    props: {
      pageData,
      preview,
    },
  }
}

export default WhyStrapi
